
import Vue from 'vue'
import floatWindow from '@/components/floatWindow.vue'

Vue.component('FloatWindow', floatWindow)
//Vue.use(floatWindow)

